import { render, staticRenderFns } from "./mailTemplates.vue?vue&type=template&id=792244a4"
import script from "./mailTemplates.vue?vue&type=script&lang=js"
export * from "./mailTemplates.vue?vue&type=script&lang=js"
import style0 from "./mailTemplates.vue?vue&type=style&index=0&id=792244a4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792244a4')) {
      api.createRecord('792244a4', component.options)
    } else {
      api.reload('792244a4', component.options)
    }
    module.hot.accept("./mailTemplates.vue?vue&type=template&id=792244a4", function () {
      api.rerender('792244a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/mailTemplates.vue"
export default component.exports